import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IWithdrawUnitsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IWithdrawUnitsDto
>("stores.warehouses.withdrawUnits");

export const withdrawUnits = {
  ...postApis,
};
